<template>
  <div class="lightbox-wrapper">
    <span @click="toggleLightbox(true)">
      <slot />
    </span>
    <div
      v-if="showLightBox"
      class="zood-lightbox overlay"
    >
      <el-row
        align="center"
        type="flex"
        justify="center"
        class="flex-full flex-column-items"
      >
        <span
          class="close el-icon-close"
          @click="toggleLightbox(false)"
        />
        <slick
          ref="slick"
          :options="slickOptions"
          @beforeChange="beforeChange"
        >
          <vue-load-image
            v-for="item in images"
            :key="item.src"
            class="slick-slide"
          >
            <img
              slot="image"
              class="carousel-img"
              :src="item.src"
              :data-src="item.src"
            >
            <div
              slot="preloader"
              v-loading="true"
              class="img-loading"
            >
              {{ $t('Loading ....') }}
            </div>
            <div slot="error">
              {{ $t('Network error') }}
            </div>
          </vue-load-image>
        </slick>
        <div :class="['slick-prev el-icon-arrow-left slick-arrow', { hidden: !showPrev }]" />
        <div :class="['slick-next el-icon-arrow-right slick-arrow', { hidden: !showNext }]" />
      </el-row>
    </div>
  </div>
</template>
<script>
import Slick from 'vue-slick';

export default {
  name: 'Lightbox',
  components: { Slick },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showPrev: false,
      showNext: this.images.length > 1,
      showLightBox: false,
      slickOptions: {
        infinite: false,
        lazyLoad: 'progressive',
        fade: true,
        prevArrow: '.slick-prev',
        nextArrow: '.slick-next',
      },
    };
  },
  methods: {
    toggleLightbox(show) {
      this.showLightBox = show;
    },
    beforeChange(e, slick, prev, next) {
      this.showPrev = next !== 0;
      this.showNext = next !== this.images.length - 1;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Lightbox.vue